<div class="container p0 clear-fix mb24">
    <div class="mb12">
        <h2 class="fs24-text fw-n">{{properties.manage.NEED_HELP}}</h2>
    </div>
    <div class="row no-gutters mb24">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
            <span class="box-border">
                <div class="row">
                    <div class="col-12">
                        <div class="fs16-text-vip">{{properties.manage.VIP_CUSTOMER_SERVICE_PHONE_LINE}}</div>
                        <div class="links__action__default vip-phone-text">
                            <a class="links__action__default" aria-label="Contact phone number : 855-767-2545" href='tel:8557672545'>
                                {{properties.manage.Num_855_767_2545}}
                            </a>
                        </div>
                        <div class="fs12-text mt10">{{properties.manage.FRESH_PASS_SUBSCRIBERS_RECEIVE_QUICK_CUSTOMER_SERVICE_FROM_A_DEDICATED_SUPPORT_TEAM}}</div>
                    </div>
                </div>
            </span>
        </div>
    </div>
</div>
